import DataQuery from 'data/DataQuery';
import { Contract_CapacityGas } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import React from 'react';
import ReservedCapacityRow from 'features/contracts/components/reservedCapacity/ReservedCapacityRow';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import ReservedCapacityGas from '../components/reservedCapacity/ReservedCapacityGas';
import CapacityGasDTO from 'features/contracts/dtos/CapacityGasDTO';
import ReservedCapacityGasHeader from '../components/reservedCapacity/ReservedCapacityGasHeader';
import { useTranslation } from 'react-i18next';

type Props = {
  contractId: string;
  year: number;
}

const CapacityGasSection = ({ contractId, year }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // fetch data
  const capacityQuery: DataQuery = {
    url: Contract_CapacityGas,
    routeParams: new URLSearchParams([["contractId", contractId!], ["year", String(year)]])
  };
  const { data: capacities, loadStatus } = useQuery<CapacityGasDTO[]>(
    capacityQuery,
    [],
    [contractId, year]
  );

  // sub-renders
  const renderCapacities = () => {
    return capacities.map((item, index) => (
      <ReservedCapacityRow key={index}>
        <ReservedCapacityGas
          capacity={item}
        />
      </ReservedCapacityRow>
    ));
  }

  // render
  return (
    <NoContentWrapper
      data={capacities}
      loadStatus={loadStatus}
      noContentAsAlert
      noContentInfo={tLabels("capacityGasSection.reservedCapacityNotFound")}
    >
      <ReservedCapacityGasHeader />
      {renderCapacities()}
    </NoContentWrapper>
  )
}

export default CapacityGasSection;